import { ScoreItem } from "components/ScoreItem";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Block, BlockBody, BlockHeader } from "styles";
import {
  getColor,
  getScoreColor,
  getScoreSlaughterColor,
  getScoreSlaughterText,
  getScoreText,
  getTotalScore,
} from "utils/globalFunctions";
import Score from "react-apexcharts";
import { Button } from "components/Button";
import { useState } from "react";
import { Icons } from "components/Icons";
import { CreateEdit } from "../../Slaughter/CreateEdit";
import isMobile from "is-mobile";

export function Slaughters({ responseReport, location, customer, match }) {
  const [showSlaughter, setShowSlaughter] = useState(false);

  const [slaughterId, setSlaughterId] = useState("");

  return (
    <>
      {showSlaughter ? (
        <CreateEdit
          show={showSlaughter}
          setShow={setShowSlaughter}
          location={location}
          customer={customer}
          id={slaughterId}
          match={match}
        />
      ) : null}
      <Block>
        <BlockHeader>Abates do período</BlockHeader>
        <BlockBody>
          {responseReport.slaughters.map((item) => (
            <ScoreItem
              key={item._id}
              title={item.customer?.name}
              scoreColor={getScoreSlaughterColor(
                Math.round(item.total * 100) / 100
              )}
              text={[item.responsible || "", `Lote: ${item.batchCode || ""}`]}
              description={[
                item.evaluationDate
                  ? `Avaliação ${format(
                      new Date(item.evaluationDate),
                      "dd MMM y",
                      {
                        locale: ptBR,
                      }
                    )}`
                  : null,
              ]}
              score={
                <Score
                  options={{
                    plotOptions: {
                      radialBar: {
                        startAngle: -135,
                        endAngle: 225,
                        hollow: {
                          margin: 0,
                          size: "70%",
                          background: "#f9f9fc ",
                          image: undefined,
                          imageOffsetX: 0,
                          imageOffsetY: 0,
                          position: "front",
                        },
                        track: {
                          background: getColor(
                            getScoreSlaughterColor(
                              Math.round(item.total * 100) / 100
                            ),
                            0.2
                          ),
                          strokeWidth: "67%",
                          margin: 0, // margin is in pixels
                        },

                        dataLabels: {
                          showOn: "always",
                          name: {
                            offsetY: -5,
                            show: true,
                            color: getScoreSlaughterColor(
                              Math.round(item.total * 100) / 100
                            ),
                            fontSize:
                              getScoreSlaughterText(
                                Math.round(item.total * 100) / 100
                              ) === "Muita Atenção"
                                ? "5px"
                                : "7px",
                          },
                          value: {
                            formatter: function (val) {
                              return (
                                Math.round(val * 100) /
                                100 /
                                10
                              ).toLocaleString();
                            },
                            color: getScoreSlaughterColor(
                              Math.round(item.total * 100) / 100
                            ),
                            fontSize: "10px",
                            show: true,
                            offsetY: -5,
                          },
                        },
                      },
                    },
                    fill: {
                      colors: [
                        getScoreSlaughterColor(
                          Math.round(item.total * 100) / 100
                        ),
                      ],
                      type: "gradient",
                      gradient: {
                        shade: "dark",
                        type: "horizontal",

                        gradientToColors: [
                          getScoreSlaughterColor(
                            Math.round(item.total * 100) / 100
                          ),
                        ],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 0.8,
                        stops: [0, 100],
                      },
                    },
                    stroke: {
                      lineCap: "round",
                    },
                    labels: [
                      getScoreSlaughterText(Math.round(item.total * 100) / 100),
                    ],
                  }}
                  series={[(Math.round(item.total * 100) / 100) * 10]}
                  type="radialBar"
                  width={isMobile() ? "90%" : "110"}
                />
              }
              button={
                <Button
                  bg={getScoreSlaughterColor(
                    Math.round(item.total * 100) / 100
                  )}
                  border={getScoreSlaughterColor(
                    Math.round(item.total * 100) / 100
                  )}
                  onClick={() => {
                    setSlaughterId(item._id);
                    setShowSlaughter(true);
                  }}
                  color="white"
                  size="sm"
                >
                  <Icons type="etc" color="#fff" size="15" />
                </Button>
              }
            />
          ))}
        </BlockBody>
      </Block>
    </>
  );
}
